export default __webpack_public_path__ + "static/media/tarra-logotype-d.111b5ef5.svg";